import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap"
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Activity, Common } from "../../../../helper"
import { isEmptyObject } from "../../../../util";
import { LoadingSpinner } from "../../Loader";
import * as dashboardApi from "../../../../api/dashboardApi"

import "../../../../assets/stlyes/Dashboard/ActivityRating.scss"

import ActivityStar from "../../../../assets/images/ActivityStar.png"
import ActivityCircle from "../../../../assets/images/ActivityCircle.svg"

const ActivityRating = () => {
  const currentUser = useSelector(state => state.userData.userInfo)
  const [isLoading, setIsLoading] = useState(false);
  const [currentUserRank, setCurrentUserRank] = useState();
  const [lowestRank, setLowestRank] = useState();
  const [ranks, setRanks] = useState([]);

  const [totalEvidencesByCurrentUser, setTotalEvidencesByCurrentUser] = useState();
  const [averageEvidences, setAverageEvidences] = useState();
  const [diffInEvidence, setDiffInEvidence] = useState();
  const [highestTotalEvidences, setHighestTotalEvidences] = useState();

  const [averageObjectivesMarked, setAverageObjectivesMarked] = useState();
  const [objectivesMarkedByCurrentUser, setObjectivesMarkedByCurrentUser] = useState();
  const [diffInObjectivesMarked, setDiffInObjectivesMarked] = useState();
  const [highestTotalObjectivesMarked, sethighestTotalObjectivesMarked] = useState()

  const [totalAssessmentsByCurrentUser, setTotalAssessmentsByCurrentUser] = useState();
  const [averageAssessments, setAverageAssessments] = useState();
  const [diffInAssessments, setDiffInAssessments] = useState();
  const [highestTotalAssessments, setHighestTotalAssessments] = useState();

  const [negObjectivesMarked, setNegObjectivesMarked] = useState(0);
  const [posObjectivesMarked, setPosObjectivesMarked] = useState(0);
  const [negAssessments, setNegAssessments] = useState(0);
  const [posAssessments, setPosAssessments] = useState(0);
  const [negEvidences, setNegEvidences] = useState(0);
  const [posEvidences, setPosEvidences] = useState(0);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: "14px",
    width: "100px",
    borderRadius: "0px 5px 5px 0px !important",
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#F2F2F2"
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 0,
      transform: "",
      backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8"
    }
  }));

  const getTeachersRankings = async () => {
    setIsLoading(true)
    const teacherRatings = await dashboardApi.getTeacherRating()
    teacherRatings.Items.sort((a, b) => a - b)
    if (!(isEmptyObject(teacherRatings))) {
      let rank = teacherRatings.Items.filter(k => k.userId === currentUser.id)[0].yourRank
      let rankList = (teacherRatings.Items.map(k => k.yourRank))
      setCurrentUserRank(rank)
      setLowestRank(rankList && rankList[rankList.length - 1])
      let currentUserRanks = rank;
      let lowestRanks = rankList[rankList.length - 1];
      let highestRanks = rankList[0];
      switch (rankList.length) {
      case 0: setRanks([])
        break;
      case 1: setRanks([currentUserRanks])
        break;
      case 2: currentUserRanks === highestRanks ? setRanks([lowestRanks, currentUserRanks]) : setRanks([currentUserRanks, highestRanks])
        break;
      case 3: currentUserRanks === highestRanks ? setRanks([lowestRanks, currentUserRanks + 1, currentUserRanks]) : currentUserRanks === lowestRanks ? setRanks([currentUserRanks, currentUserRanks - 1, highestRanks]) : setRanks([lowestRanks, currentUserRanks, highestRanks])
        break;
      case 4: switch (currentUserRanks) {
      case highestRanks: setRanks([lowestRanks, currentUserRanks + 2, currentUserRanks + 1, currentUserRanks])
        break;
      case highestRanks + 1: setRanks([lowestRanks, currentUserRanks + 1, currentUserRanks, highestRanks])
        break;
      case lowestRanks - 1: setRanks([lowestRanks, currentUserRanks, currentUserRanks - 1, highestRanks])
        break;
      case lowestRanks: setRanks([currentUserRanks, currentUserRanks - 1, currentUserRanks - 2, highestRanks])
        break;
      }
        break;
      case 5: switch (currentUserRanks) {
      case highestRanks: setRanks([lowestRanks, lowestRanks - 1, currentUserRanks + 2, currentUserRanks + 1, currentUserRanks])
        break;
      case highestRanks + 1: setRanks([lowestRanks, lowestRanks - 1, currentUserRanks + 1, currentUserRanks, highestRanks])
        break;
      case highestRanks + 2: setRanks([lowestRanks, currentUserRanks + 1, currentUserRanks, currentUserRanks - 1, highestRanks])
        break;
      case lowestRanks - 1: setRanks([lowestRanks, currentUserRanks, currentUserRanks - 1, highestRanks + 1, highestRanks])
        break;
      case lowestRanks: setRanks([currentUserRanks, currentUserRanks - 1, currentUserRanks - 2, highestRanks + 1, highestRanks])
        break;
      }
        break;
      default: switch (currentUserRanks) {
      case highestRanks: setRanks([lowestRanks, lowestRanks - 1, currentUserRanks + 2, currentUserRanks + 1, currentUserRanks])
        break;
      case highestRanks + 1: setRanks([lowestRanks, lowestRanks - 1, currentUserRanks + 2, currentUserRanks, highestRanks])
        break;
      case highestRanks + 2: setRanks([lowestRanks, currentUserRanks + 1, currentUserRanks, currentUserRanks - 1, highestRanks])
        break;
      case lowestRanks - 1: setRanks([lowestRanks, currentUserRanks, currentUserRanks - 1, highestRanks + 1, highestRanks])
        break;
      case lowestRanks: setRanks([currentUserRanks, currentUserRanks - 1, currentUserRanks - 2, highestRanks + 1, highestRanks])
        break;
      default: setRanks([lowestRanks, currentUserRanks + 1, currentUserRanks, currentUserRanks - 1, highestRanks])
        break;
      }
        break;
      }
    }
    setIsLoading(false)
  }

  const getTotalObjectivesMarked = async () => {
    const TotalObjectivesMarked = await dashboardApi.getTotalObjectivesMarked();
    setAverageObjectivesMarked(TotalObjectivesMarked && TotalObjectivesMarked.Items.overallAverage)
    setObjectivesMarkedByCurrentUser(TotalObjectivesMarked && TotalObjectivesMarked.Items.currentUserTotalAverage)
    setDiffInObjectivesMarked((TotalObjectivesMarked.Items.currentUserTotalAverage && TotalObjectivesMarked.Items.currentUserTotalAverage) - TotalObjectivesMarked.Items.overallAverage)
    let objMarked = (TotalObjectivesMarked && TotalObjectivesMarked.Items.userAverage.map(obj => obj.average)).sort(function (a, b) { return b - a })
    let diffInObj = (TotalObjectivesMarked.Items.currentUserTotalAverage - TotalObjectivesMarked.Items.overallAverage);
    sethighestTotalObjectivesMarked(objMarked && objMarked[0])
    if (diffInObj === 0) {
      setPosObjectivesMarked(0)
      setNegObjectivesMarked(0)
    } else if (diffInObj === objMarked[0]) {
      setPosObjectivesMarked(100)
    } else if (diffInObj === objMarked[objMarked.length - 1]) {
      setNegObjectivesMarked(100)
    } else {
      if (diffInObj > 0) {
        setPosObjectivesMarked((diffInObj * 100) / highestTotalObjectivesMarked)
        setNegObjectivesMarked(0)
      } else if (diffInObj < 0) {
        setNegObjectivesMarked(Math.abs((diffInObj * 100) / TotalObjectivesMarked.Items.overallAverage))
        setPosObjectivesMarked(0)
      }
    }

  }

  const getTotalEvidencesUploaded = async () => {
    const TotalEvidencesUploaded = await dashboardApi.getActivityRatingEvidenceUploaded();
    setTotalEvidencesByCurrentUser(TotalEvidencesUploaded && TotalEvidencesUploaded.Items.currentUserEvidences)
    setAverageEvidences(Math.round(TotalEvidencesUploaded && TotalEvidencesUploaded.Items.averageEvidence))
    setHighestTotalEvidences(TotalEvidencesUploaded && TotalEvidencesUploaded.Items.userWithHighestEvidences.evidenceCount)
    setDiffInEvidence(Math.round(TotalEvidencesUploaded.Items.currentUserEvidences && TotalEvidencesUploaded.Items.averageEvidence && TotalEvidencesUploaded.Items.currentUserEvidences - (TotalEvidencesUploaded.Items.averageEvidence)))
    let evidenceUpd = (TotalEvidencesUploaded.Items.userEvidencesCount).sort(function (a, b) { return b.evidenceCount - a.evidenceCount })
    let diffInEvd = TotalEvidencesUploaded.Items.currentUserEvidences - TotalEvidencesUploaded.Items.averageEvidence;
    if (diffInEvd === 0) {
      setPosEvidences(0)
      setNegEvidences(0)
    } else if (diffInEvd === (evidenceUpd[0].evidenceCount && evidenceUpd[0].evidenceCount)) {
      setPosEvidences(100)
    } else if (diffInEvd === evidenceUpd[evidenceUpd.length - 1].evidenceCount) {
      setNegEvidences(100)
    } else {
      if (diffInEvd > 0) {
        setPosEvidences(Math.round((diffInEvd * 100) / evidenceUpd[0].evidenceCount))
        setNegEvidences(0)
      } else if (diffInEvd < 0) {
        setNegEvidences((Math.abs(diffInEvd) * 100) / TotalEvidencesUploaded.Items.averageEvidence)
        setPosEvidences(0)
      }
    }
  }

  const getTotalWritingAssessments = async () => {
    const totalWritingAssessments = await dashboardApi.getActivityRatingWritingAssessment();
    setTotalAssessmentsByCurrentUser(totalWritingAssessments.Items.currentUserAssmtSubmittedCount && totalWritingAssessments.Items.currentUserAssmtSubmittedCount)
    setAverageAssessments(totalWritingAssessments.Items.assessmentSubmittedAverage && totalWritingAssessments.Items.assessmentSubmittedAverage)
    setDiffInAssessments(Math.round((totalWritingAssessments.Items.currentUserAssmtSubmittedCount && totalWritingAssessments.Items.currentUserAssmtSubmittedCount) - (totalWritingAssessments.Items.assessmentSubmittedAverage && totalWritingAssessments.Items.assessmentSubmittedAverage)))
    setHighestTotalAssessments(totalWritingAssessments.Items.highestAssmtSubmittedCount && totalWritingAssessments.Items.highestAssmtSubmittedCount)
    let assmtUpd = totalWritingAssessments.Items.teachers.sort(function (a, b) { return b.assessmentSubmittedCount - a.assessmentSubmittedCount });
    let diffInAssmt = totalWritingAssessments.Items.currentUserAssmtSubmittedCount - totalWritingAssessments.Items.assessmentSubmittedAverage;
    
    if (diffInAssmt === 0) {
      setNegAssessments(0)
      setPosAssessments(0)
    } else if (diffInAssmt === (assmtUpd[0].assessmentSubmittedCount && assmtUpd[0].assessmentSubmittedCount)) {
      setPosAssessments(100);
      setNegAssessments(0)
    } else if (diffInAssmt === assmtUpd[assmtUpd.length - 1].assessmentSubmittedCount) {
      setNegAssessments(100)
      setPosAssessments(0)
    } else {
      if (diffInAssmt > 0) {
        setPosAssessments((Math.round(diffInAssmt * 100)) / assmtUpd[0].assessmentSubmittedCount)
        setNegAssessments(0)
      } else if (diffInAssmt < 0) {
        setPosAssessments(0)
        setNegAssessments(Math.abs((Math.round(diffInAssmt * 100)) / totalWritingAssessments.Items.assessmentSubmittedAverage))
      }
    }
  }

  useEffect(() => {
    setIsLoading(true)
    getTotalObjectivesMarked()
    getTotalEvidencesUploaded()
    getTotalWritingAssessments()
    getTeachersRankings()
  }, [])

  useEffect(() => {
    console.log("Consoles List", { totalEvidencesByCurrentUser, averageEvidences, diffInEvidence, highestTotalEvidences, averageObjectivesMarked, objectivesMarkedByCurrentUser, diffInObjectivesMarked, highestTotalObjectivesMarked, totalAssessmentsByCurrentUser, averageAssessments, diffInAssessments, highestTotalAssessments, negObjectivesMarked, posObjectivesMarked, negAssessments, posAssessments, negEvidences, posEvidences });
  }, [totalEvidencesByCurrentUser, averageEvidences, diffInEvidence, highestTotalEvidences, averageObjectivesMarked, objectivesMarkedByCurrentUser, diffInObjectivesMarked, highestTotalObjectivesMarked, totalAssessmentsByCurrentUser, averageAssessments, diffInAssessments, highestTotalAssessments, negObjectivesMarked, posObjectivesMarked, negAssessments, posAssessments, negEvidences, posEvidences])

  return (
    <div className="ActivityRating">
      {isLoading && <LoadingSpinner />}
      {!isLoading && currentUserRank && <Row>
        <Col xs={6} md={3} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <Row style={{ display: "flex" }}>
            <Col xs={12}>
              <span className="ActivityRating-heading">{Activity.Activity}</span>
            </Col>
            <Col xs={12}>
              <span className="ActivityRating-sub-heading">{Activity.ActivityDescription}</span>
            </Col>
          </Row>
        </Col>
        <Col xs={6} md={3} style={{ padding: 0 }}>
          <div style={{ display: "flex", justifyContent: "flex-start", minWidth: "250px", alignItems: "center" }}>
            <img src={currentUserRank <= 3 ? ActivityStar : ActivityCircle} alt="" />
            <span className="teacherRankingNumber">
              {currentUserRank && currentUserRank}
            </span>
          </div>
        </Col>
        <Col xs={12} md={6}>
          {!isLoading && <Row style={{ fontSize: "10px" }}>
            <Col xs={12}>
              <Row style={{ height: "40px", alignItems: "flex-start" }}>
                <Col xs={4}>
                  {currentUserRank && <Row style={{ width: "-webkit-fill-available" }}>
                    <Col xs={8}>
                      <span style={{ textTransform: "uppercase", fontSize:"0.75vw" }}>{Common.Ranking}</span>
                    </Col>
                    <Col xs={4} style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start" }}>
                      <span style={{fontSize:"0.75vw"}}>{`${currentUserRank && currentUserRank} / ${lowestRank && lowestRank}`}</span>
                    </Col>
                  </Row>}
                </Col>
                <Col>
                  <Row>
                    <Col xs={9}>
                      {ranks && < div className="activity-ranking-graph">
                        <span className="activity-rank-bar" style={{ width: "auto" }}></span>
                        <div className="d-flex justify-content-between" style={{ display: "flex" }}>
                          {currentUserRank && ranks && ranks.map((rank, i) => {
                            return (
                              ((rank === currentUserRank)) ? <Tooltip title={currentUserRank} placement="top"><span key={i} style={{ display: "flex", resize: "contain", backgroundColor: "#F4C900", height: "22px", width: "22px", borderRadius: "38px", color: "#FFF", textAlign: "center", fontFamily: "Manrope", fontSize: "7px", fontStyle: "normal", fontWeight: "800", lineHeight: "120%", textTransform: "uppercase", position: "relative", top: "-13px", zIndex: 2, padding: "7px 3px" }} >{Common.You}</span></Tooltip>
                                : <span key={i} style={{ display: "flex", backgroundColor: "#26C8B9", height: "14px", width: "14px", borderRadius: "38px", padding: "3px 4px", color: "#FFF", textAlign: "center", fontFamily: "Manrope", fontSize: "7px", fontStyle: "normal", fontWeight: "800", lineHeight: "120%", textTransform: "uppercase", position: "relative", top: "-10px" }}  >{rank}</span>
                            )
                          })}
                        </div>
                      </div>}
                    </Col>
                  </Row>
                </Col>
                <Col xs={2}>
                  {currentUserRank && <Row>
                    <Col xs={12}>
                      {/* <span style={{ textTransform: "uppercase" }}>{Common.Ranking}</span> */}
                    </Col>
                  </Row>}
                </Col>
              </Row>
              <Row style={{ height: "40px", alignItems: "flex-start" }}>
                <Col xs={4}>
                  <Row style={{ width: "-webkit-fill-available" }}>
                    <Col xs={8}>
                      <span style={{ textTransform: "uppercase", fontSize: "0.75vw" }}>{Common.ObjectivesMarked}</span>
                    </Col>
                    <Col xs={4} style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start" }}>
                      <span style={{fontSize: "0.75vw"}}>{`${objectivesMarkedByCurrentUser && objectivesMarkedByCurrentUser}%`}</span>
                    </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  <Row >
                    <Col xs={12}>
                      <div style={{ display: "flex" }}>
                        <BorderLinearProgress variant="determinate" value={negObjectivesMarked && negObjectivesMarked} className="red-bar" style={{ transform: "rotate(180deg)", borderLeft: "2px solid white" }} />
                        <BorderLinearProgress variant="determinate" value={posObjectivesMarked && posObjectivesMarked} className="blue-bar" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={2}>
                  <Row>
                    <Col xs={10}>
                      <span style={{ textTransform: "uppercase", marginLeft: "20%", fontSize: "0.75vw" }}>{diffInObjectivesMarked > 0 ? `+ ${diffInObjectivesMarked}%` : diffInObjectivesMarked < 0 ? `- ${Math.round(Math.abs(diffInObjectivesMarked))}%` : `${diffInObjectivesMarked}%`}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ height: "40px", alignItems: "flex-start" }}>
                <Col xs={4}>
                  <Row style={{ width: "-webkit-fill-available" }}>
                    <Col xs={8}>
                      <span style={{ textTransform: "uppercase", fontSize: "0.75vw" }}>{Common.WritingAssessment}</span>
                    </Col>
                    <Col xs={4} style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start" }}>
                      <span style={{fontSize: "0.75vw"}}>{`${totalAssessmentsByCurrentUser && totalAssessmentsByCurrentUser}`}</span>
                    </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  <Row >
                    <Col xs={12}>
                      <div style={{ display: "flex" }}>
                        <BorderLinearProgress variant="determinate" value={negAssessments && negAssessments} className="red-bar" style={{ transform: "rotate(180deg)", borderLeft: "2px solid white" }} />
                        <BorderLinearProgress variant="determinate" value={posAssessments && posAssessments} className="blue-bar" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={2}>
                  <Row>
                    <Col xs={10}>
                      <span style={{ textTransform: "uppercase", marginLeft: "20%", fontSize: "0.75vw" }}>{diffInAssessments > 0 ? `+ ${diffInAssessments}` : diffInAssessments < 0 ? `- ${Math.round(Math.abs(diffInAssessments))}` : diffInAssessments}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ height: "40px", alignItems: "flex-start" }}>
                <Col xs={4}>
                  <Row style={{ width: "-webkit-fill-available" }}>
                    <Col xs={8}>
                      <span style={{ textTransform: "uppercase", fontSize: "0.75vw" }}>{Common.EvidenceUploaded}</span>
                    </Col>
                    <Col xs={4} style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start" }}>
                      {totalEvidencesByCurrentUser && <span style={{fontSize: "0.75vw"}}>{`${totalEvidencesByCurrentUser && totalEvidencesByCurrentUser}`}</span>}
                    </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  <Row >
                    <Col xs={12}>
                      <div style={{ display: "flex" }}>
                        <BorderLinearProgress variant="determinate" value={negEvidences && negEvidences} className="red-bar" style={{ transform: "rotate(180deg)", borderLeft: "2px solid white" }} />
                        <BorderLinearProgress variant="determinate" value={posEvidences && posEvidences} className="blue-bar" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={2}>
                  <Row>
                    <Col xs={10}>
                      <span style={{ textTransform: "uppercase", marginLeft: "20%", fontSize: "0.75vw" }}>{diffInEvidence && diffInEvidence > 0 ? `+ ${diffInEvidence}` : ((diffInEvidence && diffInEvidence < 0) ? `- ${Math.round(Math.abs(diffInEvidence))}` : `${diffInEvidence}`)}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>}
        </Col>
      </Row >}
    </div >
  )
}

export { ActivityRating }